// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"PullQuote_quoteContainer__1RNZx","quote":"PullQuote_quote__5QL0L","author":"PullQuote_author__WYgLh"};